"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicensingObject = void 0;
var LicensingObject;
(function (LicensingObject) {
    LicensingObject["UNKNOWN"] = "Unknown";
    LicensingObject["DESKTOP_DEVICE"] = "DesktopDevice";
    LicensingObject["MOBILE_DEVICE"] = "MobileDevice";
    LicensingObject["USER"] = "User";
    LicensingObject["MAILBOX"] = "Mailbox";
})(LicensingObject || (exports.LicensingObject = LicensingObject = {}));
